import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

export class MyUploadAdapter {
  private url = environment.url;

  constructor(
    private http: HttpClient
  ) {}

  upload(file) {
    return new Promise((resolve) => {
      const formData = new FormData();
      formData.append('file', file);
      return this.http
        .post(`${this.url}/ckediter/store`, formData)
        .subscribe(res => {
          resolve(res)
        });
    })
  }

  abort() {
    console.error('aborted');
  }
}
